import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentVehicleHoldings } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { toHoldingRows } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.utils.ts';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';

interface Result {
	rows: InvestorHoldingRow[];
	isLoading: boolean;
	isError: boolean;
}

export const useVehicleHoldings = ({ personId }: { personId: string }): Result => {
	const holdingsQuery = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_HOLDINGS_GET, { personId }],
		queryFn: ({ signal }) =>
			getInvestmentVehicleHoldings(
				API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_HOLDINGS_GET,
				{ personId },
				signal
			),
	});

	const payload = holdingsQuery.data?.payload;

	const rows = useMemo(() => toHoldingRows(payload), [payload]);

	return { rows, isLoading: holdingsQuery.isPending, isError: holdingsQuery.isError };
};
